import type { CareerPath, CareerPathFitLevel } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const DESC_STRINGS = appStrings.modules.careerPath.detailPage.description;

export const useAgentContext = (
  careerPath: CareerPath,
  fitLevel: CareerPathFitLevel,
  bestFitMajorNames: string[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Description',
    description:
      'Overview of the career path including its description, fit level badge, a Lubav-generated explanation of why this career path is a fit for the user, key metrics (growth outlook, early career hires volume, caregiver flexibility score), and best fit majors as clickable pills.',
    detail: `Growth modal: "${DESC_STRINGS.growthModal.subtitle}" Early Career Hires modal: "${DESC_STRINGS.earlyCareerHiresModalDescription}"`,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Path Overview',
    display:
      'Left side shows the career path description and a Lubav-generated fit explanation with a "Discuss with Lubav" button. Right side shows key metrics (Growth, Early Career Hires, Caregiver Flexibility) and Best Fit Majors as clickable pill chips.',
    data: {
      fitLevel,
      growth: careerPath.growth,
      early_career_hires: careerPath.early_career_hires_per_year,
      caregiver_flexibility: careerPath.caregiver_flexibility?.caregiver_flexibility_score,
      bestFitMajors: bestFitMajorNames,
    },
  });
};
